import {
  NavbarFloatingDrawerContainer,
  NavbarFloatingDrawerVStack,
  NavbarFloatingDrawerNavLinksList,
  NavbarFloatingDrawerNavLink,
  NavbarFloatingDrawerFooter,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingDrawer = {
  Container: NavbarFloatingDrawerContainer,
  VStack: NavbarFloatingDrawerVStack,
  NavLinksList: NavbarFloatingDrawerNavLinksList,
  NavLink: NavbarFloatingDrawerNavLink,
  Footer: NavbarFloatingDrawerFooter,
};
